import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/passion-painting/back_blue.webp";
import { StaticImage } from "gatsby-plugin-image";

function Fivestep() {
  return (
    <section className="five_step" style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="fivestep_img">
              <StaticImage
                src="../../../images/case-studies/passion-painting/five_step_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={443}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>A Simplistic Five Step Process</h2>
            <p>
              We have designed the Interactive client form for Passion Painting
              to power maximum convenience for users. The process starts with
              providing minimal personal details, describing your property,
              designing the job, finalizing the paint and then ends with you
              finally getting the most affordable quote based on your
              requirements.
            </p>
            <p>
              You can customize every single detail, with nothing being missed
              out anywhere. It takes just under two minutes to get this form
              filled, if you have all the information at hand. Nowhere else in
              the industry, will you find this level of automated customer
              facilitation as on Passion Painting.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Fivestep;
